import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FaLinkedin, FaTwitter, FaFacebook, FaWeixin } from 'react-icons/fa';

const StyledFooter = styled.footer`
  background-color: ${props => props.theme.colors.darkGray};
  color: white;
  padding: ${props => props.theme.spacing.xl} 0;
`;

const FooterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.md};
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${props => props.theme.spacing.lg};

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`;

const FooterSection = styled.div`
  margin-bottom: ${props => props.theme.spacing.lg};
`;

const FooterTitle = styled.h4`
  color: white;
  margin-bottom: ${props => props.theme.spacing.md};
  font-size: 1.2rem;
  position: relative;
  padding-bottom: ${props => props.theme.spacing.sm};

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 50px;
    height: 2px;
    background-color: ${props => props.theme.colors.primary};
  }
`;

const FooterLink = styled(Link)`
  color: #ccc;
  display: block;
  margin-bottom: ${props => props.theme.spacing.sm};
  transition: color ${props => props.theme.transitions.fast};

  &:hover {
    color: white;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  margin-top: ${props => props.theme.spacing.md};
`;

const SocialIcon = styled.a`
  color: white;
  font-size: 1.5rem;
  margin-right: ${props => props.theme.spacing.md};
  transition: color ${props => props.theme.transitions.fast};

  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: ${props => props.theme.spacing.xl};
  padding-top: ${props => props.theme.spacing.md};
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: #ccc;
`;

const Footer = () => {
  const { t } = useTranslation();

  return (
    <StyledFooter>
      <FooterContainer>
        <FooterSection>
          <FooterTitle>IMEETTECH</FooterTitle>
          <p>
            {t('home.intro').substring(0, 150)}...
          </p>
          <SocialLinks>
            <SocialIcon href="#" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </SocialIcon>
            <SocialIcon href="#" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </SocialIcon>
            <SocialIcon href="#" target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </SocialIcon>
            <SocialIcon href="#" target="_blank" rel="noopener noreferrer">
              <FaWeixin />
            </SocialIcon>
          </SocialLinks>
        </FooterSection>

        <FooterSection>
          <FooterTitle>{t('footer.quickLinks')}</FooterTitle>
          <FooterLink to="/">{t('footer.home')}</FooterLink>
          <FooterLink to="/solutions">{t('header.solutions')}</FooterLink>
          <FooterLink to="/products">{t('header.products')}</FooterLink>
          <FooterLink to="/pricing">{t('header.pricing')}</FooterLink>
          <FooterLink to="/partners">{t('header.partners')}</FooterLink>
          <FooterLink to="/resources">{t('header.resources')}</FooterLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>{t('footer.about')}</FooterTitle>
          <FooterLink to="/about">{t('footer.about')}</FooterLink>
          <FooterLink to="/services">{t('footer.services')}</FooterLink>
          <FooterLink to="/cases">{t('footer.cases')}</FooterLink>
          <FooterLink to="/contact">{t('footer.contact')}</FooterLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>{t('services.customSoftware.title')}</FooterTitle>
          <FooterLink to="/services">{t('services.customSoftware.offerings.enterprise')}</FooterLink>
          <FooterLink to="/services">{t('services.customSoftware.offerings.mobile')}</FooterLink>
          <FooterLink to="/services">{t('services.customSoftware.offerings.web')}</FooterLink>
          <FooterLink to="/services">{t('services.customSoftware.offerings.api')}</FooterLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>{t('contact.info.title')}</FooterTitle>
          <p>{t('contact.info.address')}: 123 Tech Street, Shanghai, China</p>
          <p>{t('contact.info.email')}: info@imeettech.com</p>
          <p>{t('contact.info.phone')}: +86 123 4567 8910</p>
          <p>{t('contact.info.hours')}: 9:00-18:00 (Mon-Fri)</p>
        </FooterSection>
      </FooterContainer>

      <Copyright>
        {t('footer.copyright')}
      </Copyright>
    </StyledFooter>
  );
};

export default Footer;